import API_URLS from '../../constants/api-urls';
import { FOLDER_DIRECTORIES } from '../../constants/folder';
import axios from '../../utils/axios';

export const postFolderMaterialsQuery = (directory: FOLDER_DIRECTORIES, query: string) =>
    axios.post(
        API_URLS.FOLDERS.FOLDER_MATERIALS,
        { query },
        {
            params: {
                type: directory
            }
        }
    );
